export default {
  // FrontPage.vue
  frontPageRequirementTitle: 'Recherche',
  frontPageProvideTitle: 'Propose',
  frontPagePersonalCenterTitle: 'Profil',
  login: 'Se connecter',
  home_chatWithOctopie: 'Comprendre tes pensées',
  home_chatNeedUnderstood: 'Tes pensées ont été comprises',
  home_draftBannerTitle: 'Termine ton message',
  home_draftBannerSubtitle: 'L\'IA a déjà préparé ton message — touche pour continuer',
  home_tabHome: 'Accueil',

  // App.vue
  appRequirementTitle: 'Chaque suggestion et chaque retour compte pour nous',
  appRequirementBtn: 'Envoyer',
  appSubmitSuccess: 'Envoyé avec succès, merci pour ton retour',
  appFeedbackLink: 'Suggestions/Retours',
  mobile_banner_text: 'Pour la meilleure expérience, utilise notre app',
  mobile_banner_btn: 'Obtenir l\'app',

  // Common
  loading: 'Chargement...',
  confirm: 'Confirmer',
  cancel: 'Annuler',
  save: 'Enregistrer',
  delete: 'Supprimer',
  edit: 'Modifier',
  add: 'Ajouter',
  search: 'Rechercher',
  refresh: 'Actualiser',
  change_batch: 'Mélanger',
  back: 'Retour',
  submit: 'Envoyer',
  close: 'Fermer',
  ok: 'OK',
  yes: 'Oui',
  no: 'Non',
  send: 'Envoyer',
  block: 'Bloquer',
  more: 'Plus',
  logout: 'Se déconnecter',
  settings: 'Paramètres',
  view_guide: 'Voir le guide',
  feedback: 'Retours',
  feedback_title: 'Retours',
  feedback_new: 'Nouveau retour',
  feedback_empty: 'Aucun retour pour le moment',
  feedback_hint: 'Dis-nous ce que tu en penses...',
  feedback_submit: 'Envoyer',
  feedback_submit_success: 'Retour envoyé avec succès',
  feedback_submit_failed: 'Échec de l\'envoi du retour',
  feedback_reply_label: 'Réponse de la plateforme',
  register: 'S\'inscrire',
  name: 'Nom',
  email: 'E-mail',
  mobile: 'Téléphone',
  password: 'Mot de passe',
  verification_code: 'Code de vérification',
  company_name: 'Beijing Liangshao Technology Co., Ltd.',
  all_rights_reserved: 'Tous droits réservés.',
  footerVersion: 'Version {version}',
  copy: 'Copier',
  regenerate: 'Régénérer',
  generate: 'Générer',
  contact_now: 'Discuter',
  yours: 'toi',
  xiaoyao_analysis: 'Analyse IA',
  brand_name: 'OctoSay',
  anonymous: 'Anonyme',
  no_summary: 'Pas de résumé',
  file: 'Fichier',
  discover: 'Découvrir',
  discover_title: 'Découvrir',
  discover_hotChannels: 'Canaux populaires',
  discover_allChannels: 'Tous',
  discover_searchChannel: 'Rechercher un canal',
  discover_noChannels: 'Aucun canal trouvé',

  // Messages
  operationSuccess: 'Opération réussie',
  operationFailed: 'Échec de l\'opération',
  networkError: 'Erreur réseau, réessaie plus tard',
  dataLoadingFailed: 'Échec du chargement des données',
  noData: 'Aucune donnée',
  deleteConfirm: 'Veux-tu vraiment supprimer ?',
  saveConfirm: 'Veux-tu vraiment enregistrer ?',

  // Form Validation
  required: 'Ce champ est obligatoire',
  emailInvalid: 'Veuillez saisir une adresse e-mail valide',
  phoneInvalid: 'Veuillez saisir un numéro de téléphone valide',
  passwordTooShort: 'Le mot de passe doit contenir au moins {min} caractères',
  passwordMismatch: 'Les mots de passe ne correspondent pas',

  // Time
  today: 'Aujourd\'hui',
  yesterday: 'Hier',
  justNow: 'À l\'instant',
  minutesAgo: 'il y a {min} min',
  hoursAgo: 'il y a {hour} h',
  daysAgo: 'il y a {day} j',

  // Footer
  about: 'À propos',
  footerPrivacy: 'Politique de confidentialité',
  footerTerms: 'Conditions d\'utilisation',
  footerSupport: 'Aide et assistance',

  // Register
  registerAgeConfirm: 'Je confirme avoir au moins 13 ans',
  registerAgeConfirm18: 'Je confirme avoir au moins 18 ans',
  registerTermsPrefix: 'J\'ai lu et j\'accepte ',
  registerTermsAnd: ' et ',
  registerAgeError: 'Veuillez confirmer votre âge',
  registerTermsError: 'Veuillez accepter les conditions et la politique de confidentialité',

  // Chat
  chatPrivacyTip: 'Écris ton message dans le groupe et l\'IA discutera d\'abord avec toi pour clarifier. Une fois que tu confirmes, ton message et le résumé IA sont publiés ensemble et AI continue de chercher des matchs.',
  aiChat_quickSuggestions: 'Essaie de dire',
  aiChat_welcome: "Salut ! Dis-moi ce que tu cherches.",

  // Chat - AI Progress Steps (new)
  aiChat_readyToPost: 'Détails compris — publie pour trouver ton match',
  aiChat_readyToPostHint: 'Continue à discuter pour ajouter des détails ou mettre à jour le résumé à tout moment',
  aiChat_progressStep1: 'Comprendre les détails',
  aiChat_progressStep1Done: 'Détails compris',
  aiChat_progressStep2: 'Résumé IA',
  aiChat_progressStep2Desc: 'AI crée un résumé pour le matching',
  aiChat_progressStep3: 'Publier dans le Groupe',
  aiChat_progressStep3Desc: 'Publie et trouve ton match',
  aiChat_publishExtraHint: 'Saisis ton message pour le groupe',
  aiChat_publishMsgRequired: 'Obligatoire',
  aiChat_publishMsgLabel: 'Ton message pour le groupe',
  aiChat_matchSummaryLabel: 'Résumé IA',

  ai_generated_label: 'AI Generated',

  ai_content_disclaimer: 'Le contenu suivant est généré par IA, à titre de référence uniquement.',
  aiChat_publishSuggestionHint: 'Touche pour remplacer',
  aiChat_allowDirectContact: 'Autoriser le contact direct',
  aiChat_allowDirectContactDesc: 'Les autres peuvent te contacter directement sans match',
  channel_chat_session_publishToChannel: 'Publier dans l\'Groupe Octo',
  aiChat_newChat: 'Réinitialiser',

  // Channels / Groupes
  home_tabChannels: 'Groupes Octo',
  channels_title: 'Groupes Octo',
  channels_myChannels: 'Groupes rejoints',
  channels_discover: 'Découvrir',
  channels_noChannels: 'Pas encore de groupes',
  channels_noMyGroupsTitle: 'Tu n\'as encore rejoint aucun groupe',
  channels_noMyGroupsSubtitle: 'Cherche un groupe à rejoindre et commence à créer des liens',
  channels_searchGroupsBtn: 'Rechercher des groupes',
  channels_loginPrompt: 'Connecte-toi pour voir les groupes',
  channels_create: 'Créer un Groupe Octo',
  channels_search: 'Rechercher des Groupes Octo',
  channels_searchMyGroups: 'Rechercher mes Groupes Octo',
  channels_searchHint: 'Rechercher',
  channels_searchHintChats: 'Rechercher des discussions...',
  channels_searchHintGroups: 'Rechercher des groupes...',
  channels_searchHintMy: 'Rechercher parmi les groupes rejoints...',
  channels_joinByCode: 'Rejoindre par code',
  channels_joinByCodeTitle: 'Rejoindre un Groupe Octo par code',
  channels_joinByCodeHint: 'Saisis le code Groupe Octo',
  channels_joinByCodeConfirm: 'Rejoindre',
  channels_joinByCodeNotFound: 'Groupe introuvable',
  channels_createNewGroup: 'Créer un nouvel Groupe Octo',
  channels_noResults: 'Aucun groupe trouvé',
  channel_detail_join: 'Rejoindre',
  channel_detail_leave: 'Quitter',
  channel_detail_members: 'membres',
  // 聚合进群消息 banner（joinMsgs）
  channelJoinMsg_oneJoined: '{name} a rejoint le hub',
  channelJoinMsg_twoJoined: '{name1} et {name2} ont rejoint le hub',
  channelJoinMsg_multiJoined: '{name1}, {name2} et {n} autres ont rejoint le hub',
  channelJoinMsg_oneAndMoreJoined: '{name} et {n} autres ont rejoint le hub',
  channelJoinMsg_membersJoined: '{n} membres ont rejoint le hub',

  // Feed
  channels_feed: 'Discussions',
  channels_groups: 'Groupes',
  feed_related: 'Similaires',
  feed_recommend: 'Recommandés',
  feed_empty: 'Pas encore de fil, explore les groupes populaires',
  feed_goToGroup: 'Voir dans le groupe',
  feed_joinGroupAndSendMsg: 'Rejoins un groupe et envoie un message',
  channel_detail_channelCode: 'Code Groupe Octo',
  channel_detail_invitePhrase: 'Invitation à rejoindre « {name} »\nCode d\'invitation {code} — ouvrez l\'app pour rejoindre automatiquement · L\'IA clarifie d\'abord, puis trouve les bonnes personnes',
  channel_detail_post: 'Publier dans le Groupe',
  channel_detail_aiHint: "Tapez votre message dans le groupe et AI clarifiera d'abord les détails",
  channel_input_hint: 'Dis quelque chose...',
  channel_leave_confirm_message: 'Veux-tu vraiment quitter ce groupe ? Tu ne recevras plus les messages du groupe.',
  channel_invite_notFound: 'Groupe introuvable ou lien expiré',
  channel_invite_joinBtn: 'Télécharger l\'app OctoSay',
  channel_invite_hint: 'Télécharge l\'app, puis scanne ce code QR ou recherche le nom du groupe pour rejoindre',
  channel_invite_globalHintTitle: 'Tu es sur le point de télécharger la version mondiale',
  channel_invite_globalHintIOS: 'Cette app n\'est peut-être pas disponible sur l\'App Store de Chine. Passe à un Apple Store hors de Chine et recherche OctoSay, ou télécharge l\'APK directement ci-dessous.',
  channel_invite_globalHintAndroid: 'Google Play n\'est peut-être pas accessible dans ta région. Nous te conseillons de télécharger l\'APK directement, ou d\'essayer Google Play.',
  channel_invite_globalHintDefault: 'L\'app n\'est peut-être pas disponible dans ta boutique locale. Nous te conseillons de télécharger l\'APK directement, ou d\'essayer l\'App Store.',
  channel_invite_globalBtnAppStore: 'Aller sur l\'App Store',
  channel_invite_globalBtnGooglePlay: 'Aller sur Google Play',
  channel_invite_globalBtnAPK: 'Télécharger l\'APK directement',
  channel_invite_defaultDesc: 'Rejoins {name} sur OctoSay',
  share: 'Partager',
  share_channel: 'Partager le groupe',
  share_channel_link: 'Partager le lien',
  channel_detail_inviteCode: 'Code d\'invitation',
  channel_detail_copyLink: 'Copier le lien',
  share_session_title: 'Une publication sur OctoSay',
  share_match_title: 'Un match sur OctoSay',
  share_session_text: '{userName} : {summary}',
  share_session_text_no_summary: 'Regarde ce que {userName} a publié sur OctoSay',
  session_share_notFound: 'Publication introuvable ou lien expiré',
  session_share_fromChannel: 'Depuis un Groupe Octo',
  session_share_downloadBtn: 'Télécharger l\'app OctoSay',
  session_share_hint: 'Télécharge l\'app pour voir la publication complète et rejoindre le groupe',
  session_share_openInApp: 'Ouvrir dans l\'app',
  toast_link_copied: 'Lien copié',
  toast_no_share_data: 'Rien à partager',
  channels_joinByQR: 'Code QR',
  channels_joinByQRWebHint: 'Le web ne prend pas en charge le scan QR. Saisis le code du groupe pour rejoindre.',
  channels_joinByQRTitle: 'Rejoindre par code QR',
  channel_detail_qrCode: 'Code QR',
  channel_detail_qrCodeSave: 'Enregistrer l\'image',
  channel_detail_qrCodeSaveHint: 'Fais un clic droit sur l\'image pour l\'enregistrer',
  channel_detail_qrCodeSaved: 'Enregistré dans l\'album',
  channel_detail_qrCodeSaveFailed: 'Échec de l\'enregistrement, réessaie',
  channel_detail_locateFailed: 'Échec de la localisation du message',
  channel_detail_locateError: 'Erreur lors de la localisation du message',
  channel_detail_myMessages: 'Mes messages',
  channel_detail_searchMessages: 'Rechercher des messages',
  channel_detail_aiChat: 'Discussion avec AI',
  channel_detail_matchHistory: 'Historique des matchs',
  channel_create_title: 'Créer un Groupe Octo',
  channel_create_name: 'Nom de l\'Groupe Octo',
  channel_create_description: 'Description',
  channel_create_submit: 'Créer',
  channelCreate_aiAssist: 'AI t\'aidera à créer un groupe adapté',
  channelCreate_nameHint: 'Saisis un nom pour ton groupe',
  channelCreate_descHint: 'Décris le but de ton groupe',
  channelCreate_creating: 'Création...',
  channelCreate_created: 'Groupe créé !',
  channelCreate_failed: 'Échec de la création du groupe',
  channelCreate_welcomeMsg: "Salut ! Je suis là pour vous aider à créer un groupe. Dites-moi quel type de groupe vous souhaitez — son sujet ou son objectif — et je le transformerai en nom et introduction de groupe, puis je générerai aussi un avatar.",
  channelCreate_aiHint: 'Écris le sujet de ton groupe...',
  channelCreate_clarifyingProgress: 'Organisation du sujet de ton groupe...',
  channelCreate_readyToCreate: 'Prêt à créer l\'Groupe Octo',
  channelCreate_step1: 'Décrire le sujet',
  channelCreate_step1Done: 'Idée clarifiée',
  channelCreate_step2: 'Créer un Groupe Octo',
  channelCreate_confirmBtn: 'Confirmer la création',
  channelCreate_publicNotice: "Les groupes sont des espaces publics où des personnes partageant les mêmes intérêts se rassemblent et se connectent. La plateforme peut gérer, mettre à jour ou fusionner les groupes si nécessaire. N'hésitez pas à partager ce groupe avec d'autres personnes qui pourraient être intéressées.",
  channelCreate_similarGroupsTitle: 'Groupes Octo similaires trouvés',
  channelCreate_similarGroupsDesc: 'Ces groupes pourraient correspondre à ce que tu cherches',
  channelCreate_exactMatchHint: 'Un groupe portant exactement ce nom existe déjà !',
  channelCreate_joinHint: 'Ces groupes existants pourraient bien te correspondre',
  channelCreate_joinExisting: 'Rejoindre un Groupe Octo existant',
  channelCreate_stillCreate: 'Créer quand même un nouvel Groupe Octo',
  channel_chat_session_comments: 'Commentaires',
  channel_chat_session_commentHint: 'Écris un commentaire...',
  channel_chat_session_sendComment: 'Commenter',
  channel_chat_session_loadMore: 'Charger plus',
  channel_chat_session_noComments: 'Pas encore de commentaires',
  channel_chat_session_deleteComment: 'Supprimer',
  channelSearch_title: 'Rechercher dans le Groupe',
  channelSearch_placeholder: 'Rechercher des messages...',
  channelSearch_onlyMine: 'Uniquement mes publications',
  channelSearch_tabAllMessages: 'Messages du groupe',
  channelSearch_tabMyMessages: 'Mes messages',
  chatMsgSearch_placeholder: 'Rechercher des messages',
  chatMsgSearch_tabMsgs: 'Messages',
  chatMsgSearch_tabContacts: 'Contacts',
  chatMsgSearch_emptyPrompt: 'Saisis des mots-clés pour rechercher des messages',
  chatMsgSearch_tooShort: 'Saisis au moins 2 caractères pour rechercher',
  chatMsgSearch_contactEmptyPrompt: 'Saisis un nom d\'utilisateur ou un e-mail pour rechercher des contacts',
  chatMsgSearch_noContacts: 'Aucun contact correspondant',
  chatMsgSearch_inChatPlaceholder: 'Rechercher dans cette discussion',
  channelHistory_title: 'Historique',
  channelHistory_myMessages: 'Mes messages',
  channelHistory_loadMore: 'Charger plus',
  channel_settings_push: 'Notifications Groupe Octo',
  channel_settings_commentPush: 'Notifications de commentaires',
  channel_settings_likePush: 'Notifications de likes',
  channel_settings_receiveNotifications: 'Recevoir les notifications',
  channel_settings_directContact: 'Autoriser le contact direct',
  session_published: 'Publié',
  session_publishFailed: 'Échec de la publication',
  session_setDirectContactSuccess: 'Paramètre enregistré',
  session_setDirectContactFailed: 'Échec de l\'enregistrement du paramètre',
  session_setPrivate: 'Rendre privé',
  session_setPublic: 'Rendre public',
  session_pauseMatching: 'Mettre le match en pause',
  session_resumeMatching: 'Relancer le match',
  session_matchPausedToast: 'Match en pause',
  session_matchResumedToast: 'Match relancé',
  match_matchingPausedTitle: 'Le match est en pause',
  match_reasonTag: 'Raison du match',
  match_matchingPausedHint: 'Réactivez le match à tout moment.',
  session_confirmSetPrivate: 'Rendre ce contenu privé ? Les autres utilisateurs ne pourront pas le voir.',
  session_messageIsPrivate: 'Ce message est privé',
  chatSessionComment_replyHint: 'Écris un commentaire...',
  chatSessionComment_reply: 'Commenter',
  chatSessionComment_count: '{n} commentaire | {n} commentaires',
  chatSessionMatch_count: '{n} match | {n} matchs',
  chatSessionComment_replyTo: 'Répondre',
  chatSessionComment_inputHint: 'Écris un commentaire...',
  chatSessionComment_send: 'Envoyer',
  chatSessionComment_delete: 'Supprimer',
  chatSessionComment_deleteConfirm: 'Veux-tu vraiment supprimer ce commentaire ?',
  chatSessionComment_loadMore: 'Charger plus',
  chatSessionComment_noMore: 'Plus de commentaires',
  chatSessionComment_loginToComment: 'Connecte-toi pour commenter',
  chatSessionComment_viewEarlier: 'Voir les {n} réponses précédentes',
  chatSessionLike_like: 'J\'aime',
  chatSessionLike_liked: 'Aimé',
  chatSessionLike_count: 'j\'aime',
  chatSessionBookmark_bookmark: 'Enregistrer',
  chatSessionBookmark_bookmarked: 'Enregistré',
  chatSessionMatch_viewMatches: 'Voir les matchs',
  chatSessionMatch_matchHistory: 'Historique des matchs',
  chatSessionMatch_noMatches: 'Pas encore de matchs',
  channel_match_achievement: '{count} publications ont trouvé un match avec succès',
  channel_match_achievement_view: 'Voir →',
  channel_matchHistory_title: 'Historique des matchs du canal',
  chatSessionMatch_matchedAt: 'Matché à {time}',
  discover_userMsgLabel: 'L\'utilisateur a dit',
  common_loading: 'Chargement...',
  common_sending: 'Envoi...',
  common_error: 'Erreur',
  common_success: 'Succès',
  common_me: 'Moi',

  // Chat - Set Public / Pick Location
  aiChat_clarifyingProgress: "L'IA clarifie votre besoin pour que chaque message publié soit efficace ; après publication, elle continue à vous trouver des matchs",
  aiChat_clarifyingAlmostDone: 'Presque terminé, confirme s\'il te plaît',
  aiChat_clarifyingOneMore: 'Encore environ 1 question, puis tu pourras publier',
  aiChat_clarifyingRemaining: 'Encore environ {count} tours, presque terminé',
  aiChat_clarifyingEvaluating: 'Évaluation des progrès...',
  aiChat_setPublicMatch: 'Rendre public et matcher',
  aiChat_needsClarifiedPublic: "Je vous comprends maintenant. Une fois confirmé et publié, AI continuera à chercher des matchs pour vous.\nN'hésitez pas à partager plus de détails à tout moment.",
  aiChat_needsClarifiedPrivate: 'C\'est compris ! Rends-le public et laisse-moi continuer à te trouver des matchs !\nDis-moi plus de détails à tout moment.',
  aiChat_setPublicTitle: 'Rendre public',
  aiChat_setPublicMessage: 'Ton contenu sera visible par les autres afin qu\'OctoSay trouve des matchs complémentaires pour toi.\n\nInformations qui seront partagées :\n• Ton nom d\'utilisateur et ton avatar\n• Le résumé de ton contenu\n• Le contenu de la conversation (visible dans Découvrir)\n\nTu peux le rendre privé à tout moment.',
  aiChat_findMatches: 'Voir le résultat du match',
  aiChat_publishing: 'Publication...',
  aiChat_matchSectionTitle: 'Votre message convient le mieux à ces groupes — touchez pour publier',
  aiChat_joinedBadge: 'Membre',
  aiChat_matchSectionEmpty: 'Pas encore de groupe bien matché — vous pouvez créer un nouveau groupe et y publier',
  aiChat_suggestPublishCreateNew: 'Créer un nouveau groupe',
  aiChat_repickChannel: 'Changer de groupe',
  aiChat_creatingChannelTitle: 'Aucun groupe adapté — création en cours pour vous',
  aiChat_creatingChannelHint: 'L’IA crée un groupe selon votre demande, puis vous passez directement à la publication — généralement 10 à 30 s',
  aiChat_publishToChannelHint: 'Sera publié dans « {name} »',
  aiChat_pickChannelTitle: 'Choisissez un groupe pour publier',
  aiChat_matchingChannelTitle: 'Recherche du groupe idéal pour vous',
  aiChat_matchingChannelHint: 'Recherche en cours selon votre demande — prend généralement de quelques secondes à une demi-minute',
  aiChat_matchUnavailableTitle: 'Recommandations indisponibles',
  aiChat_matchUnavailableHint: 'Recherchez un groupe ci-dessous ou fermez puis rouvrez la publication',
  aiChat_waitSlowHint: 'Cela prend plus de temps que d’habitude, mais c’est toujours en cours — patientez encore un peu ou recherchez un groupe ci-dessous',
  aiChat_creatingSlowHint: 'La création prend plus de temps que d’habitude, mais c’est toujours en cours — la publication suivra directement',
  aiChat_pickChannelEmptyHint: 'Aucun groupe trouvé. Créez un nouveau groupe pour publier votre message',
  aiChat_loadMore: 'Afficher plus',
  sidebar_publish: 'Publier',
  chat_selectLocationOnMap: 'Veuillez sélectionner un lieu sur la carte',

  // App.vue new
  placeholder_email: 'Saisis ton e-mail',
  placeholder_mobile: 'Saisis ton numéro de téléphone',
  placeholder_password: 'Saisis ton mot de passe',
  placeholder_name: 'Saisis ton nom',
  random_nickname: 'Aléatoire',
  placeholder_verification_code: 'Saisis le code de vérification',
  sending: 'Envoi...',
  registering: 'Inscription...',
  send_code: 'Envoyer le code',
  retry_in_seconds: 'Nouvelle tentative dans {countdown}s',
  toast_enter_email: 'Veuillez saisir votre e-mail',
  toast_enter_mobile: 'Veuillez saisir votre numéro de téléphone',
  toast_invalid_email: 'Veuillez saisir un format d\'e-mail valide',
  toast_invalid_mobile: 'Veuillez saisir un numéro de téléphone valide',
  toast_send_code_failed: 'Échec de l\'envoi du code de vérification',
  toast_code_sent: 'Code de vérification envoyé par e-mail',
  toast_code_sent_sms: 'Code de vérification envoyé par SMS',
  toast_send_code_error: 'Échec de l\'envoi du code de vérification, réessaie plus tard',
  toast_fill_all_fields: 'Veuillez remplir tous les champs',
  toast_login_failed: 'Échec de la connexion',
  toast_login_success: 'Connexion réussie',
  oauthOr: 'ou',
  toast_oauth_login_failed: 'Échec de la connexion Google',
  toast_oauth_login_error: 'Erreur de connexion Google, réessaie',
  toast_login_error: 'Échec de la connexion, réessaie plus tard',
  toast_register_failed: 'Échec de l\'inscription',
  toast_register_success: 'Inscription réussie',
  toast_register_error: 'Échec de l\'inscription, réessaie plus tard',

  // AdBanner.vue
  ad: 'Pub',

  // ContactAdGate.vue 联系前广告闸门
  contactAd_gateTitle: 'Avant de vous connecter',
  contactAd_gateSubtitle: 'Cette courte pause permet à OctoSay de rester gratuit — merci pour votre soutien !',
  contactAd_waitBtn: 'Continuer dans {sec}s',
  contactAd_continueBtn: 'Continuer vers le chat',

  // ChannelDetail.vue 私聊按钮
  session_privateChat: 'Discuter',

  // AiMatch.vue
  ai_welcome_msg: 'Salut, je suis AI. Dis-moi ce que tu as en tête — un compagnon, un partenaire, un échange de compétences, ou N\'IMPORTE QUOI.',
  default_username: 'Utilisateur',

  // AvatarCropDialog.vue
  crop_hint: 'Pince pour zoomer, glisse pour ajuster',
  toast_crop_failed: 'Échec du recadrage de l\'image',

  // ChatBox.vue
  loading_match_info: 'Chargement des infos de match...',
  view_match_details: 'Voir les détails du match',
  step_clarify_needs: 'Clarifier',
  step_ai_matching: 'Publier dans le Groupe',
  step_connect: 'Match IA',
  make_private: 'Rendre privé',
  setting: 'Paramétrage...',
  action_photo: 'Photo',
  action_file: 'Fichier',
  action_video: 'Vidéo',
  action_location: 'Position',
  hint_get_app: 'Obtiens l\'app pour rester en contact',
  match_finding_title: 'Tes matchs',
  match_finding_subtitle: 'AI continue de chercher des matchs pour toi',
  match_time_hint: 'Ce processus prend généralement 1 à 2 minutes',
  match_result_stats: '{matched} meilleurs matchs trouvés{interested}',
  match_tap_to_connect: 'Touche pour lancer ta conversation',
  match_channel_hint: 'Matching dans le groupe <strong>#{channel}</strong>. Priorité aux matchs du même groupe, mais d\'autres groupes peuvent être inclus si nécessaire.',
  label_perfect_match: 'Meilleur match',
  label_worth_a_look: 'À voir',
  match_no_result_title: 'On cherche toujours des matchs pour toi',
  match_no_result_desc: 'Partage plus de détails pour aider OctoSay à trouver les bons matchs. Installe l\'app pour recevoir des notifications quand quelqu\'un te matche.',
  go_back: 'Retour',
  no_public_requirements: 'Pas encore de publications publiques',
  channelEmpty_title: 'C\'est calme par ici',
  channelEmpty_subtitle: 'Sois le premier à partager tes pensées',
  channelEmpty_hint: "Écrivez vos idées et AI vous aidera à les clarifier et continuera à matcher, pour que votre message ne passe pas inaperçu",
  channelEmpty_action: 'Partage tes pensées',
  stay_connected: 'Reste en contact',
  download_app_desc: 'Obtiens l\'app pour discuter et recevoir des notifications instantanées quand quelqu\'un te contacte !',
  app_store: 'App Store',
  google_play: 'Google Play',
  direct_apk: 'APK direct',
  match_history: 'Historique des matchs',
  no_match_history: 'Pas encore d\'historique de matchs',
  finding_matches: 'AI continue de chercher des matchs pour toi - Après avoir publié un message dans un groupe',
  discover_connect_hint: 'Tu pourras discuter avec eux une fois matché !',
  match_initializing: 'Initialisation...',
  placeholder_login_to_chat: 'connecte-toi pour me dire ce que tu as en tête',
  toast_need_clear: 'Ton idée est claire !',
  toast_ai_responding: 'AI est en train de répondre, patiente...',
  toast_uploading_image: 'Envoi de l\'image, patiente...',
  toast_uploading_file: 'Envoi du fichier, patiente...',
  toast_max_photos: 'Maximum {max} photos autorisées',
  toast_uploading: 'Envoi en cours, patiente...',
  toast_file_too_large: '{name} dépasse la limite de 5 Mo',
  toast_video_too_large: '{name} dépasse la limite de 20 Mo',
  toast_video_processing: 'La vidéo est en cours de traitement, patiente...',
  toast_upload_link_failed: 'Échec de l\'obtention du lien d\'envoi',
  analyzing_image: 'Analyse de l\'image...',
  toast_location_confirmed: 'Position confirmée',
  toast_location_selected: 'Position sélectionnée',
  toast_enter_search: 'Veuillez saisir le contenu à rechercher',
  toast_search_failed: 'Échec de la recherche',
  toast_no_locations: 'Aucun lieu trouvé',
  toast_search_error: 'Échec de la recherche, réessaie',
  toast_located_at: 'Localisé à : {address}',
  toast_shared_finding: 'Partagé ! Recherche de matchs...',
  toast_update_failed: 'Échec de la mise à jour',
  toast_set_private: 'Rendu privé',
  toast_no_matches: 'Aucun match trouvé',
  toast_matches_found: '{count} meilleurs matchs trouvés',
  toast_start_conversation_first: 'Lance d\'abord une conversation',
  toast_load_history_failed: 'Échec du chargement de l\'historique des matchs',
  toast_ai_timeout: 'AI a mis trop de temps à répondre, réessaie',
  toast_message_blocked: 'Message bloqué',
  network_disconnected: 'Réseau déconnecté',
  toast_publish_success: 'Publié dans le groupe !',
  toast_publish_failed: 'Échec de la publication dans le groupe',

  // ChatMsgList.vue
  collapse_thinking: 'réduire la réflexion',
  expand_thinking: 'développer la réflexion',
  thinking: 'réfléchit',
  select_date: 'Choisir une date',
  selected_location: 'Position sélectionnée',
  msg_blocked: 'Bloqué',
  retry: 'Réessayer',
  msg_read: 'Lu',
  msg_sent: 'Envoyé',
  msg_unread: 'Non lu',
  label_start_datetime: 'Date et heure de début :',
  label_end_datetime: 'Date et heure de fin :',
  toast_select_start_datetime: 'Veuillez sélectionner une date et une heure de début',
  toast_end_before_start: 'La date/heure de fin ne peut pas précéder celle de début',
  report_message: 'Signaler le message',
  block_user: 'Bloquer l\'utilisateur',
  msg_revoke: 'Retirer',
  msg_quote: 'Citer',
  msg_revoked_self: 'Tu as retiré un message',
  msg_revoked_other: 'L\'autre personne a retiré un message',
  // Neutral text inside quote block: the revoker is the sender of the quoted message, unrelated to current message direction
  msg_revoked_generic: 'Message retiré',
  // Platform removal (content moderation manual review), distinct from self-revoke
  msg_revoked_platform: 'Ce message a été retiré par la plateforme pour non-respect des règles',
  msg_blocked_label: 'This message was blocked by the platform',
  toast_revoke_success: 'Message retiré',
  toast_revoke_failed: 'Échec du retrait du message',
  toast_load_data_failed: 'Échec du chargement des données, actualise la page.',
  toast_file_url_missing: 'URL du fichier introuvable',
  toast_block_success: 'Utilisateur bloqué avec succès',
  toast_block_failed: 'Échec du blocage de l\'utilisateur',

  // ChatSession.vue
  no_more_records: 'plus aucun enregistrement.',
  title_needs_clarified: 'Pensées clarifiées',
  title_clarifying: 'On clarifie tes pensées',
  title_public: 'Public',
  title_private: 'Privé',
  badge_clarified: 'Clarifié',
  badge_clarifying: 'En cours de clarification',
  badge_only_me: 'Seulement moi',
  badge_expired: 'Expiré',
  title_expired: 'Expiré',
  no_chat_history: 'Pas d\'historique de discussion',

  // ContactMethods.vue
  block_status_banner: 'Tu as bloqué cet utilisateur',
  unblock_user: 'Débloquer',
  toast_block_missing_id: 'Impossible de bloquer : ID utilisateur manquant',
  dialog_block_confirm: 'Veux-tu vraiment bloquer {name} ? Tu ne recevras plus aucun message de cette personne.',
  toast_user_blocked: '{name} a été bloqué',
  toast_unblock_missing_id: 'Impossible de débloquer : ID utilisateur manquant',
  toast_user_unblocked: '{name} a été débloqué',

  // BlockedUsers.vue
  blocked_users: 'Utilisateurs bloqués',
  blocked_users_empty: 'Aucun utilisateur bloqué',
  blocked_users_empty_hint: 'Les utilisateurs bloqués ne pourront plus t\'envoyer de messages',
  blocked_users_unblock: 'Débloquer',
  dialog_unblock_confirm: 'Après le déblocage, cette personne pourra t\'envoyer à nouveau des messages.',
  toast_unblock_success: 'Débloqué',
  toast_unblock_failed: 'Échec du déblocage, réessaie',
  blocked_users_load_failed: 'Échec du chargement. Touche pour réessayer',
  blocked_users_blocked_at: 'Bloqué {date}',
  blocked_users_unknown_user: 'Utilisateur inconnu',

  // Contacts.vue
  no_connections: 'Pas encore de messages',
  chat_with: 'Discuter avec {name}',
  toast_load_contacts_failed: 'Échec du chargement des contacts : {msg}',
  toast_load_contacts_error: 'Échec du chargement des contacts. Actualise et réessaie.',
  time_just_now: 'À l\'instant',
  time_minutes_ago: 'il y a {min} min',
  time_hours_ago: 'il y a {hour} h',
  time_days_ago: 'il y a {day} j',

  // InteractionNotification.vue
  interaction_notification_title: 'Notifications',
  interaction_notification_subtitle: 'Commentaires et j\'aime',
  interaction_notification_empty: 'Pas encore de notifications',
  interaction_notification_comment: 'a commenté : {content}',
  interaction_notification_like: 'a aimé ta publication',
  interaction_notification_reply: 'a répondu : {content}',
  interaction_notification_bookmark: 'a enregistré ta publication',
  toast_load_notifications_failed: 'Échec du chargement des notifications : {msg}',
  toast_load_notifications_error: 'Échec du chargement des notifications. Actualise et réessaie.',
  mark_all_read: 'Tout marquer comme lu',
  toast_mark_all_read_failed: 'Échec de l\'opération, réessaie',
  contacts_dnd: 'Couper les notifications',
  dnd_enabled: 'Notifications coupées',
  dnd_disabled: 'Notifications réactivées',
  dnd_action_enable: 'Couper les notifications',
  dnd_action_disable: 'Réactiver les notifications',

  // Discover.vue
  toast_load_sessions_failed: 'Échec du chargement des sessions : {msg}',
  toast_load_sessions_error: 'Échec du chargement des sessions',
  discover_noMessages: 'Pas encore de messages',

  // EmojiInputArea.vue
  placeholder_default: 'Partage plus de détails avec AI',
  userChat_typeMessage: 'Écris un message...',
  select_emoji: 'Choisir un emoji',
  badge_new: 'nouveau',
  channel_search_placeholder: 'Saisis le canal',
  channel_picker_empty: 'Saisis le canal',

  // FrontPage.vue
  tab_chat_with_ai: 'Laisse OctoSay te comprendre',
  history_chats: 'Historique',
  tab_connections: 'Matchs',
  tab_conversations: 'Messages',
  tab_profile: 'Profil',
  new_session: 'Nouveau',
  history_tab_chats: 'À moi',
  history_tab_matches: 'Matchs',
  channels_octosay: 'Groupes Octo',
  tab_matches: 'Matchs',
  tab_messages: 'Messages',

  // Header.vue
  slogan: 'OctoSay - L\'IA qui te comprend et te connecte à la bonne personne',
  app_name: 'OctoSay',
  slogan_short: 'L\'IA qui te comprend et te connecte à la bonne personne',
  slogan_ai: 'L\'IA qui te comprend et te connecte à la bonne personne',
  get_the_app: 'Obtenir l\'app',
  desc_iphone_ipad: 'iPhone / iPad',
  desc_android: 'Android',
  search_in_app_stores: 'ou recherche OctoSay dans les app stores',

  // MapLocationPicker.vue
  placeholder_search_location: 'Rechercher un lieu...',
  coords_display: 'Longitude : {lng}, Latitude : {lat}',
  toast_no_geolocation: 'Ton navigateur ne prend pas en charge la géolocalisation',
  toast_location_permission_denied: 'Impossible d\'obtenir ta position, vérifie les autorisations de localisation',
  loading_address: 'Chargement de l\'adresse...',

  // MatchedSession.vue
  created_at: 'Créé : {time}',
  ai_match_analysis: 'Analyse de match par AI',
  error_missing_session_params: 'Paramètres de session requis manquants',
  match_private_hint: 'Cette session est privée. Contenu non disponible',

  // PersonalCenter.vue
  label_name: 'Nom :',
  placeholder_enter_name: 'Saisis ton nom',
  label_bio: 'Bio :',
  placeholder_enter_bio: 'Écris quelque chose sur toi',
  placeholder_bio_empty: 'Dis quelque chose sur toi',
  bio: 'Bio',
  delete_account: 'Supprimer le compte',
  delete_warning: 'Cette action est irréversible.',
  delete_data_intro: 'Les données suivantes seront définitivement supprimées :',
  delete_item_profile: 'Les informations de ton profil',
  delete_item_chat: 'Historique et sessions de discussion',
  delete_item_contact: 'Informations de contact',
  delete_item_all: 'Toutes les données associées',
  final_confirmation: 'Confirmation finale',
  delete_confirm_prompt: 'Tape "delete" pour confirmer :',
  placeholder_type_delete: 'Tape delete',
  private_token: 'Jeton privé',
  token_desc: 'Génère un jeton pour l\'accès API',
  toast_not_logged_in: 'Utilisateur non connecté',
  toast_name_required: 'Le nom est obligatoire',
  toast_save_success: 'Enregistré avec succès',
  toast_save_failed: 'Échec de l\'enregistrement',
  toast_image_too_large: 'L\'image dépasse la limite de 5 Mo',
  toast_avatar_updated: 'Avatar mis à jour',
  toast_avatar_failed: 'Échec de la mise à jour de l\'avatar',
  toast_upload_failed: 'Échec de l\'envoi',
  toast_token_generated: 'Jeton généré',
  toast_token_failed: 'Échec de la génération du jeton',
  toast_copied: 'Copié dans le presse-papiers',
  toast_copy_failed: 'Échec de la copie',
  toast_account_deleted: 'Compte supprimé avec succès',
  toast_delete_account_failed: 'Échec de la suppression du compte',
  toast_logout_success: 'Déconnexion réussie',
  toast_logout_failed: 'Échec de la déconnexion',
  profile_tab_messages: 'Messages',
  profile_tab_comments: 'Commentaires',
  profile_tab_likes: 'J\'aime',
  profile_tab_bookmarks: 'Enregistrés',
  profile_empty_messages: 'Pas encore de messages',
  profile_empty_comments: 'Pas encore de commentaires',
  profile_empty_likes: 'Pas encore de j\'aime',
  profile_empty_bookmarks: 'Rien d\'enregistré pour le moment',
  profile_reply_to: 'Répondre à {name}',
  profile_stats_posts: 'Messages',
  profile_stats_comments: 'Commentaires',
  profile_stats_likes: 'J\'aime reçus',
  profile_joined: 'Inscrit le {date}',

  // ReportDialog.vue
  report_message_title: 'Signaler le message',
  report_reason_prompt: 'Sélectionne la raison du signalement de ce message :',
  report_spam: 'Spam',
  report_harassment: 'Harcèlement ou intimidation',
  report_inappropriate: 'Contenu inapproprié',
  report_other: 'Autre',
  placeholder_report_desc: 'Décris le problème (facultatif)',
  toast_select_reason: 'Sélectionne une raison',
  toast_report_success: 'Signalement envoyé avec succès',
  toast_report_failed: 'Échec de l\'envoi du signalement',

  // common.js
  ellipsis: '..',

  // ChatBox.vue / ChatMsgList.vue message summary prefixes
  summary_image: '[Image]',
  summary_images: '[Images×{count}]',
  summary_file: '[Fichier]',
  summary_files: '[Fichiers×{count}]',
  summary_video: '[Vidéo]',
  summary_videos: '[Vidéos×{count}]',
  summary_location: '[Position]',
  summary_locations: '[Positions×{count}]',
  summary_emoji: '[Émoji]',
  summary_emojis: '[Émojis×{count}]',
  summary_voice: '[Message vocal]',
  summary_voices: '[Messages vocaux×{count}]',
  summary_mixed: '[Mixte]',
  summary_other: '[Autre]',

  // Voice messages
  voice: 'Message vocal',
  voice_recording: 'Enregistrement...',
  toast_voice_too_short: 'Enregistrement trop court',
  toast_voice_failed: 'Échec de l\'envoi du message vocal',
  toast_mic_permission_denied: 'Impossible d\'accéder au micro. Active-le dans les paramètres du navigateur',
  toast_recording_not_supported: 'L\'enregistrement vocal n\'est pas pris en charge dans ce navigateur',
  voice_load_failed: 'Échec du chargement du message vocal',

  // Expire At
  aiChat_expireLine: "Valide jusqu'au {date}, dites-le à AI à tout moment pour mettre à jour",
  aiChat_expireExpired: "Le contenu a expiré et n'est plus visible par les autres. Dites-le à AI à tout moment pour mettre à jour l'expiration",

  // MatchedSession.vue
  detail: 'Détail',

  // Match notification hints
  match_new_result_hint: 'Si de nouveaux résultats de match apparaissent, tu seras notifié. Pour une meilleure expérience, installe l\'app et reçois des notifications instantanées.',

  // Match notification hints
  match_connection_notify_hint: 'Match fait et notifié ! Vas-y, dis bonjour !',
  match_continuousMatching: "AI cherche continuellement des matchs pour vous",
  match_continuousMatchingHint: 'On te préviendra dès qu\'on trouve de nouveaux matchs',
  match_continuousMatchingOthers: "AI cherche continuellement des matchs pour eux",
  match_continuousMatchingOthersHint: 'Les nouveaux matchs apparaîtront ici au fur et à mesure',
  match_noResultsTitleOthers: 'On cherche toujours des matchs pour cette personne',
  match_noResultsHintOthers: "AI cherche continuellement des matchs pour eux. Les résultats apparaîtront ici une fois trouvés.",
  match_newMatchFound: '{n} nouveaux matchs trouvés !',
  match_worth_exploring_hint: 'C\'est toi qui décides de faire le premier pas.',

  // Matches filter tags
  filter_all: 'Tous',
  filter_best_connection: 'Meilleur match',
  filter_worth_a_look: 'À voir',

  // LandingPage.vue (CN Portal)
  landing_brand_slogan: 'OctoSay - L\'IA qui te comprend et te connecte à la bonne personne',
  landing_hero_title: 'Écris dans ton groupe — AI clarifie d\'abord, ensuite tu publies et tu obtiens des matchs.',
  landing_hero_subtitle: 'Écris le message que tu veux partager dans un Groupe Octo. Avant sa mise en ligne, AI discutera avec toi pour cerner les détails. Une fois que tu confirmes, ton message et le résumé IA sont publiés ensemble, et AI lance le matching.',
  landing_download_on: 'Télécharger sur',
  landing_get_it_on: 'Disponible sur',
  landing_direct_download: 'Téléchargement direct',
  landing_how_title: 'Comment ça marche',
  landing_step1_title: 'Écris dans le Groupe',
  landing_step1_desc: 'Écris le message que tu veux partager dans le groupe. L\'IA discutera d\'abord avec toi pour clarifier les détails, afin que chaque publication soit claire, utile et prête pour le matching — pas noyée dans le bruit.',
  landing_step2_title: 'Confirme, publie et trouve ton match',
  landing_step2_desc: 'Quand tu confirmes, ton message original et le résumé IA sont publiés ensemble dans le groupe. Ensuite, l\'IA cherche continuellement tes meilleurs matchs, pour que ton message ne soit pas enterré ni ignoré.',
  landing_step3_title: 'Connecte-toi et discute',
  landing_step3_desc: 'Quand un match est trouvé, les deux parties peuvent voir l\'historique de discussion de chacun avec AI et le résumé IA. Avec un contexte partagé, briser la glace est facile — discutez simplement naturellement.',
  // Comparison Section
  landing_comparison_title: 'Pourquoi OctoSay ?',
  landing_comparison_subtitle: 'Discussion en groupe, mais AI clarifie tes détails et te matche activement.',
  landing_comparison_other: 'Discord',
  landing_comparison_octo: 'OctoSay',
  landing_cmp1_label: 'Qualité du contenu',
  landing_cmp1_other: 'Débordement de spam, de pubs et de hors-sujet',
  landing_cmp1_octo: 'Uniquement des cartes de besoins sélectionnées par l\'IA',
  landing_cmp2_label: 'Trouver des gens',
  landing_cmp2_other: 'Publier et simplement attendre des réponses',
  landing_cmp2_octo: 'AI te matche activement',
  landing_cmp3_label: 'Niveau de bruit',
  landing_cmp3_other: 'Des centaines de messages à faire défiler',
  landing_cmp3_octo: 'Zéro bruit, chaque publication compte',
  landing_cmp4_label: 'Pour démarrer',
  landing_cmp4_other: 'Trouver un serveur, parcourir les canaux, te débrouiller seul',
  landing_cmp4_octo: 'Écris dans le groupe ; AI clarifie et matche',
  landing_cmp_other_wechat: 'WeChat',
  landing_cmp_other_xhs: 'Xiaohongshu',
  landing_cmp_other_facebook: 'Facebook',
  landing_cmp_other_reddit: 'Reddit',
  landing_cmp1_wechat: 'Discussions de groupe inondées de pubs et de spam',
  landing_cmp1_xhs: 'Des publications promotionnelles partout, difficile de savoir ce qui est vrai',
  landing_cmp1_facebook: 'Pubs et titres accrocheurs inondent ton fil',
  landing_cmp1_reddit: 'Spam et publications hors sujet partout',
  landing_cmp2_wechat: 'Uniquement via tes contacts et les invitations de groupe',
  landing_cmp2_xhs: 'Chercher soi-même et fouiller les publications',
  landing_cmp2_facebook: 'Limité à tes amis et groupes existants',
  landing_cmp2_reddit: 'Parcourir les subreddits toi-même et espérer des réponses',
  landing_cmp3_wechat: 'Faire défiler des centaines de messages de groupe',
  landing_cmp3_xhs: 'Un fil plein de recommandations et de pubs',
  landing_cmp3_facebook: 'Publications recommandées et pubs sans fin',
  landing_cmp3_reddit: 'Des centaines de commentaires à faire défiler',
  landing_cmp5_label: 'Qui fait la recherche',
  landing_cmp5_wechat: 'Demander un par un, en espérant avoir de la chance',
  landing_cmp5_xhs: 'Publier, attendre des commentaires, trier soi-même',
  landing_cmp5_facebook: 'Tu dois demander dans les groupes à droite et à gauche',
  landing_cmp5_reddit: 'Publier, attendre des réponses, puis trier',
  landing_cmp5_octo: 'L\'IA te trouve des gens automatiquement, en continu',

  landing_features_title: 'Fonctionnalités clés',
  landing_feature1_title: 'Clarifier avant de publier',
  landing_feature1_desc: 'Aucun formulaire à remplir. Écris ton message dans le groupe et AI discutera d\'abord avec toi pour poser les bonnes questions et comprendre vraiment tes besoins.',
  landing_feature2_title: 'Propre, pas chaotique',
  landing_feature2_desc: 'Ton message et le résumé IA sont publiés ensemble — OctoSay soigne chaque publication, donc pas de spam, pas de débordement hors sujet, pas de bruit à faire défiler.',
  landing_feature3_title: 'Matching proactif',
  landing_feature3_desc: 'Une fois que tu confirmes et que ton message + le résumé IA sont en ligne, AI scanne le groupe en continu pour trouver les personnes qui correspondent à ta recherche — et explique pourquoi.',
  landing_feature4_title: 'Communautés par thème, zéro bruit',
  landing_feature4_desc: 'Rejoins des groupes par thème — sport, gaming, échange linguistique, colocation — AI clarifie ton message avant publication, pour que chaque groupe reste propre et utile.',
  landing_feature5_title: 'Vie privée protégée',
  landing_feature5_desc: 'Tu peux rendre tes messages privés après envoi, visibles uniquement par toi. Contrôle total.',
  landing_feature6_title: 'Conversations qui ont du sens',
  landing_feature6_desc: 'Pas de bruit, pas de distractions — chaque message compte.',
  landing_usecases_title: 'Fonctionne pour tous les scénarios',
  landing_usecases_subtitle: 'Quoi que tu aies en tête, rejoins un groupe par thème — AI s\'occupe du matching pour que tu n\'aies pas à faire défiler et chercher',
  landing_usecase_game: 'Compagnon de jeu',
  landing_usecase_language: 'Échange linguistique',
  landing_usecase_skill: 'Échange de compétences',
  landing_usecase_roommate: 'Trouver un colocataire',
  landing_usecase_travel: 'Compagnon de voyage',
  landing_usecase_sports: 'Partenaire de sport',
  landing_usecase_study: 'Partenaire d\'étude',
  landing_usecase_anything: '...ou partage n\'importe quoi',
  landing_cta_title: 'Prêt à commencer ?',
  landing_cta_desc: 'Rejoins un groupe par thème, écris ce que tu veux partager, laisse AI clarifier les détails, puis publie et obtiens des matchs avec les bonnes personnes.',
  landing_use_now: 'Commencer maintenant',
  landing_groups: 'Groupes',

  // OnboardingPage.vue
  onboarding_skip: 'Passer',
  onboarding_next: 'Suivant',
  onboarding_getStarted: 'Commencer',
  onboarding_step1Title: "Dites ce que vous cherchez dans le groupe",
  onboarding_step1Desc: "Ce que vous cherchez ou voulez faire, dites-le simplement. L'IA discute avec vous pour clarifier les détails et en fait un besoin clair que tout le monde comprend.",
  onboarding_step2Title: 'Confirme, publie et trouve ton match',
  onboarding_step2Desc: "Une fois votre message publié dans le groupe, l'IA trouve en continu vos meilleurs matchs, pour qu'il ne soit pas noyé ni ignoré.",
  onboarding_step3Title: 'Connecte-toi et discute',
  onboarding_step3Desc: "Chaque partie peut voir la conversation de l'autre avec l'IA et ce qu'il cherche. Avec un contexte partagé, briser la glace est facile — discutez naturellement.",

  // ChannelDetail.vue
  channel_image_limit: '1 image maximum',

  // ChannelMembers.vue
  channel_members_empty: 'Pas encore de membres',
  channel_members_title: 'Membres',
  channel_role_owner: 'Propriétaire',
  channel_role_admin: 'Admin',
  channel_role_member: 'Membre',

  // Settings.vue
  settings_language: 'Langue',
  settings_language_followSystem: 'Suivre le système',

  // ChatBox.vue
  match_interested_suffix: ', {count} à découvrir',

  // ChatBox.vue - Étapes de la progression du matching IA
  match_stage_fetch_chat: 'Récupération de la conversation',
  match_stage_query_expansion: 'Extension des requêtes',
  match_stage_semantic_search: 'Recherche sémantique',
  match_stage_deep_search: 'Analyse approfondie',
  match_stage_rerank: 'Appariement intelligent',
  match_stage_refining: 'Optimisation des résultats',
  match_stage_fetch_details: 'Récupération des détails',

  // ChannelDetail.vue - Téléversement d'images
  channel_select_image: 'Veuillez sélectionner un fichier image',
  channel_image_upload_failed: 'Échec du téléversement de l\'image, veuillez réessayer',
  chatInput_channelSearchHint: "Rechercher un groupe",
}



// WEBPACK FOOTER //
// ./src/i18n/fr.js